import { createContext, useContext } from 'react';
import { AppId } from '../../ApplicationWrapper.types';

export interface ApplicationWrapperContext {
  selectedAppId?: AppId;
  isMobile: boolean;
  logOut?: () => void;
}

const applicationWrapperContext = createContext<ApplicationWrapperContext | undefined>(undefined);

export const ApplicationWrapperContextProvider = applicationWrapperContext.Provider;

export const useApplicationWrapperContext = () => {
  const value = useContext(applicationWrapperContext);

  if (!value) {
    throw new Error('You need to wrap your component with ApplicationWrapperContextProvider');
  }

  return value;
};
